import { c as _c } from "react/compiler-runtime";
import './nav-bag.scss';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { useCart } from '@sola/cart-sdk/store.tsx';
import { getFeatureFlags, getPublicConfig } from '@sola/config/lib/getters.ts';
import { useCartDrawer } from '../../contexts/cart-drawer.tsx';
const NavBagContents: React.FC<{
  displayCount: number | string | false;
}> = t0 => {
  const $ = _c(5);
  const {
    displayCount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ArkIcon iconName="shopping-bag-02" className="NavBag__icon" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== displayCount) {
    t2 = displayCount ? <span className="NavBag__count label-sm label-potent flex justify-center items-center aspect-ratio-1 absolute">{displayCount}</span> : null;
    $[1] = displayCount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export const NavBag: React.FC = () => {
  const $ = _c(21);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["priority"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    openCartDrawer
  } = useCartDrawer();
  const {
    enableHeaderCartDrawer
  } = getFeatureFlags();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getPublicConfig();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    NEXT_PUBLIC_BASE_URL_CHECKOUT: checkoutBaseUrl
  } = t1;
  const {
    actions: t2,
    cart,
    isReady: cartIsReady
  } = useCart("actions", "cart", "isReady");
  const {
    getCart
  } = t2;
  const count = cartIsReady ? cart?.items?.length ?? 0 : 0;
  const displayCount = count && count > 9 ? "9+" : count;
  let t3;
  if ($[2] !== getCart) {
    t3 = () => {
      getCart();
    };
    $[2] = getCart;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== t) {
    t5 = t("header.cart");
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const title = t5;
  if (!enableHeaderCartDrawer) {
    const t6 = cart?.checkoutUrl || checkoutBaseUrl;
    let t7;
    if ($[7] !== displayCount) {
      t7 = <NavBagContents displayCount={displayCount} />;
      $[7] = displayCount;
      $[8] = t7;
    } else {
      t7 = $[8];
    }
    let t8;
    if ($[9] !== t6 || $[10] !== t7 || $[11] !== title) {
      t8 = <Link className="NavBag flex p-comfy-xs relative" href={t6} title={title} aria-label={title}>{t7}</Link>;
      $[9] = t6;
      $[10] = t7;
      $[11] = title;
      $[12] = t8;
    } else {
      t8 = $[12];
    }
    return t8;
  }
  let t6;
  if ($[13] !== openCartDrawer) {
    t6 = () => openCartDrawer();
    $[13] = openCartDrawer;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== displayCount) {
    t7 = <NavBagContents displayCount={displayCount} />;
    $[15] = displayCount;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7 || $[19] !== title) {
    t8 = <button type="button" className="NavBag p-comfy-xs relative" aria-label={title} onClick={t6}>{t7}</button>;
    $[17] = t6;
    $[18] = t7;
    $[19] = title;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};